import React from 'react';
import { Link } from 'react-router-dom';

import Swal from 'sweetalert2';
import MUIDataTable from 'mui-datatables';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Toggle from 'react-toggle';
import {
	getGarageCategory,
	getSparePartsCategory,
	getCarDealerCategory,
	getcarWashCategory,
	getcarInsuranceCategory,
	getdrivingSchoolCategory,
	getcarProtectionCategory,
	getairConditioningCategory,
} from '../../actions/homeAction';
import {
	FormGroup,
	FormLabel,
	Tooltip,
	TextField,
	Button,
	Select,
	FormControl,
	InputLabel,
} from '@material-ui/core';
import { FaEdit } from 'react-icons/fa';

class BusinessCategoryMaster extends React.Component {
	// constructor() {
	// 	super();
	// 	this.state = {};
	// }
	state = {};
	handleStatusChange = (id,status) => {
		console.log("newArraynewArray",  id, status.target.value);

		// var isChecked = $('#cattogBtn_' + sid);
		// isChecked.prop('checked', !isChecked.prop('checked'));
		// // console.log(isChecked.prop('checked'), !isChecked.prop('checked'));
		// if (!isChecked.prop('checked') === true) {
		// 	var status = 'active';
		// } else {
		// 	var status = 'inactive';
		// }
		// let newArray = this.state.user_list;
		// var a = newArray?.find(element => {
		// 	return element?.id === sid;
		// });
		// console.log("hello",status, a);
		// a.status = status;
		// this.setState({ user_list: newArray });
		// Swal.fire('Update Status!', 'Status has been updated.', 'success');
	};

	componentDidUpdate(prevProps) {
		if (prevProps.location.pathname !== this.props.location.pathname) {
			console.log('this is tha rought path', this.props.match.params.type);
			if (this.props.match.params.type === 'GarageCategory') {
				this.props.getGarageCategory();
			} else if (this.props.match.params.type === 'SparePartsCategory') {
				this.props.getSparePartsCategory();
			} else if (this.props.match.params.type === 'CarDealersCategory') {
				this.props.getCarDealerCategory();
			} else if (this.props.match.params.type === 'CarForSaleCategory') {
				// this.props.getcarsaleListing();
			} else if (this.props.match.params.type === 'RentCarCategory') {
				// this.props.getCarRentListing();
			} else if (this.props.match.params.type === 'CarWashCategory') {
				this.props.getcarWashCategory();
			} else if (this.props.match.params.type === 'TaxiCategory') {
				// this.props.getTaxiData();
			} else if (this.props.match.params.type === 'CarTowingCategory') {
			} else if (this.props.match.params.type === 'CarInsuranceCategory') {
				this.props.getcarInsuranceCategory();
			} else if (this.props.match.params.type === 'DrivingSchoolCategory') {
				this.props.getdrivingSchoolCategory();
			} else if (this.props.match.params.type === 'CarProtectionCategory') {
				this.props.getcarProtectionCategory();
			} else if (this.props.match.params.type === 'CarConditioningCategory') {
				this.props.getairConditioningCategory();
			} else if (this.props.match.params.type === 'QuickServiceCategory') {
			} else if (this.props.match.params.type === 'CarsAgentCategory') {
			} else if (this.props.match.params.type) {
			}
		}
	}

	componentDidMount() {
		if (this.props.match.params.type === 'GarageCategory') {
			this.props.getGarageCategory();
		} else if (this.props.match.params.type === 'SparePartsCategory') {
			this.props.getSparePartsCategory();
		} else if (this.props.match.params.type === 'CarDealersCategory') {
			this.props.getCarDealerCategory();
		} else if (this.props.match.params.type === 'CarForSaleCategory') {
			// this.props.getcarsaleListing();
		} else if (this.props.match.params.type === 'RentCarCategory') {
			// this.props.getCarRentListing();
		} else if (this.props.match.params.type === 'CarWashCategory') {
			this.props.getcarWashCategory();
		} else if (this.props.match.params.type === 'TaxiCategory') {
			// this.props.getTaxiData();
		} else if (this.props.match.params.type === 'TaxiCategory') {
			// this.props.getTaxiData();
		} else if (this.props.match.params.type === 'CarTowingCategory') {
		} else if (this.props.match.params.type === 'CarInsuranceCategory') {
			this.props.getcarInsuranceCategory();
		} else if (this.props.match.params.type === 'DrivingSchoolCategory') {
			this.props.getdrivingSchoolCategory();
		} else if (this.props.match.params.type === 'CarProtectionCategory') {
			this.props.getcarProtectionCategory();
		} else if (this.props.match.params.type === 'CarConditioningCategory') {
			this.props.getairConditioningCategory();
		} else if (this.props.match.params.type === 'QuickServiceCategory') {
		} else if (this.props.match.params.type === 'CarsAgentCategory') {
		} else if (this.props.match.params.type) {
		}
	}

	// componentDidMount() {
	// 	this.props.getGarageCategory();
	// 	console.log('this is carage category', this.props.getGarageCategory);
	// }

	render() {
		let columns = [];
		if (
			// this.props.match.params.type === 'GarageCategory' ||
			// this.props.match.params.type === 'SparePartsCategory' ||
			// this.props.match.params.type === 'CarDealersCategory' ||
			this.props.match.params.type === 'RentCarCategory' ||
			// this.props.match.params.type === 'CarWashCategory' ||
			// this.props.match.params.type === 'CarInsuranceCategory' ||
			// this.props.match.params.type === 'CarProtectionCategory' ||
			// this.props.match.params.type === 'CarConditioningCategory' ||
			this.props.match.params.type === 'QuickServiceCategory' ||
			this.props.match.params.type === 'DrivingSchoolCategory'
		) {
			columns = [
				{
					name: 'category',
					label: 'Business Category',
					options: {
						filter: false,
						sort: true,
					},
				},
				
				{
					name: 'priority',
					label: 'Priority ',
					options: {
						filter: false,

						customBodyRender: (priority, tableMeta) => {

							return <span>{priority}</span>;
						},
					},
				},
				
				{
					name: 'active',
					label: 'Status',
					options: {
						filter: true,
						sort: true,
						customBodyRender: (active, tableMeta) => {
							var Id = tableMeta.rowData[3];
							// console.log(tableMeta.rowData[3]);
							return (
								<Toggle
									id={'status_' + Id}
									checked={active}
									value={active}
									onChange={this.handleStatusChange.bind(Id, active)}
								/>
							);
						},
					},
				},
				{
					name: 'categoryId',
					label: 'Actions',
					options: {
						filter: false,
						sort: true,
						customBodyRender: (categoryId) => {
							return(
								<div>
									<Link to={`/BusinessCategoryMaster/Update/DrivingSchoolCategory/${categoryId}`}>
										<FaEdit style={{fontSize: '1.4rem'}} />
									</Link>
								</div>
							)
						}
					},
				},
			];
		} else if (
			this.props.match.params.type === 'GarageCategory' ){
				columns = [
					{
						name: 'category',
						label: 'Business Category',
						options: {
							filter: false,
							sort: true,
						},
					},
					{
						name: 'priority',
						label: 'Priority ',
						options: {
							filter: false,
	
							customBodyRender: (priority, tableMeta) => {
	
								return <span>{priority}</span>;
							},
						},
					},
	
					{
						name: 'active',
						label: 'Status',
						options: {
							filter: true,
							sort: true,
							customBodyRender: (active, tableMeta) => {
								var Id = tableMeta.rowData[3];
								// console.log(tableMeta.rowData[3]);
								return (
									<Toggle
										id={'status_' + Id}
										checked={active}
										value={active}
										onChange={this.handleStatusChange.bind(Id, active)}
									/>
								);
							},
						},
					},
					{
						name: 'categoryId',
						label: 'Action',
						options: {
							filter: true,
							sort: true,
							customBodyRender: (categoryId) => {
								return (
									<div>
										<Link to={`/BusinessCategoryMaster/Update/GarageCategory/${categoryId}`}>
											<FaEdit style={{fontSize: '1.4rem'}} />
										</Link>
									</div>
								);
							},
						},
					},
				];
		} else if (
			this.props.match.params.type === 'SparePartsCategory' ){
				columns = [
					{
						name: 'category',
						label: 'Spare Part Category',
						options: {
							filter: false,
							sort: true,
						},
					},
					{
						name: 'priority',
						label: 'Priority ',
						options: {
							filter: false,
	
							customBodyRender: (priority, tableMeta) => {
	
								return <span>{priority}</span>;
							},
						},
					},
	
					{
						name: 'active',
						label: 'Status',
						options: {
							filter: true,
							sort: true,
							customBodyRender: (active, tableMeta) => {
								var Id = tableMeta.rowData[3];
								// console.log(tableMeta.rowData[3]);
								return (
									<Toggle
										id={'status_' + Id}
										checked={active}
										value={active}
										onChange={this.handleStatusChange.bind(Id, active)}
									/>
								);
							},
						},
					},
					{
						name: 'categoryId',
						label: 'Action',
						options: {
							filter: true,
							sort: true,
							customBodyRender: (categoryId) => {
								return (
									<div>
										<Link to={`/BusinessCategoryMaster/Update/SparePartsCategory/${categoryId}`}>
											<FaEdit style={{fontSize: '1.4rem'}} />
										</Link>
									</div>
								);
							},
						},
					},
				];
		} else if (
			this.props.match.params.type === 'CarDealersCategory' ){
				columns = [
					{
						name: 'category',
						label: 'Car Dealer Category',
						options: {
							filter: false,
							sort: true,
						},
					},
					{
						name: 'priority',
						label: 'Priority ',
						options: {
							filter: false,
	
							customBodyRender: (priority, tableMeta) => {
	
								return <span>{priority}</span>;
							},
						},
					},
	
					{
						name: 'active',
						label: 'Status',
						options: {
							filter: true,
							sort: true,
							customBodyRender: (active, tableMeta) => {
								var Id = tableMeta.rowData[3];
								// console.log(tableMeta.rowData[3]);
								return (
									<Toggle
										id={'status_' + Id}
										checked={active}
										value={active}
										onChange={this.handleStatusChange.bind(Id, active)}
									/>
								);
							},
						},
					},
					{
						name: 'categoryId',
						label: 'Action',
						options: {
							filter: true,
							sort: true,
							customBodyRender: (categoryId) => {
								return (
									<div>
										<Link to={`/BusinessCategoryMaster/Update/CarDealersCategory/${categoryId}`}>
											<FaEdit style={{fontSize: '1.4rem'}} />
										</Link>
									</div>
								);
							},
						},
					},
				];
		} else if (
			this.props.match.params.type === 'CarWashCategory' ){
				columns = [
					{
						name: 'category',
						label: 'Car Wash Category',
						options: {
							filter: false,
							sort: true,
						},
					},
					{
						name: 'priority',
						label: 'Priority ',
						options: {
							filter: false,
	
							customBodyRender: (priority, tableMeta) => {
	
								return <span>{priority}</span>;
							},
						},
					},
	
					{
						name: 'active',
						label: 'Status',
						options: {
							filter: true,
							sort: true,
							customBodyRender: (active, tableMeta) => {
								var Id = tableMeta.rowData[3];
								// console.log(tableMeta.rowData[3]);
								return (
									<Toggle
										id={'status_' + Id}
										checked={active}
										value={active}
										onChange={this.handleStatusChange.bind(Id, active)}
									/>
								);
							},
						},
					},
					{
						name: 'categoryId',
						label: 'Action',
						options: {
							filter: true,
							sort: true,
							customBodyRender: (categoryId) => {
								return (
									<div>
										<Link to={`/BusinessCategoryMaster/Update/CarWashCategory/${categoryId}`}>
											<FaEdit style={{fontSize: '1.4rem'}} />
										</Link>
									</div>
								);
							},
						},
					},
				];

		} else if (
			this.props.match.params.type === 'CarInsuranceCategory' ){
				columns = [
					{
						name: 'category',
						label: 'Car Insurance Category',
						options: {
							filter: false,
							sort: true,
						},
					},
					{
						name: 'priority',
						label: 'Priority ',
						options: {
							filter: false,
	
							customBodyRender: (priority, tableMeta) => {
	
								return <span>{priority}</span>;
							},
						},
					},
	
					{
						name: 'active',
						label: 'Status',
						options: {
							filter: true,
							sort: true,
							customBodyRender: (active, tableMeta) => {
								var Id = tableMeta.rowData[3];
								// console.log(tableMeta.rowData[3]);
								return (
									<Toggle
										id={'status_' + Id}
										checked={active}
										value={active}
										onChange={this.handleStatusChange.bind(Id, active)}
									/>
								);
							},
						},
					},
					{
						name: 'categoryId',
						label: 'Action',
						options: {
							filter: true,
							sort: true,
							customBodyRender: (categoryId) => {
								return (
									<div>
										<Link to={`/BusinessCategoryMaster/Update/CarInsuranceCategory/${categoryId}`}>
											<FaEdit style={{fontSize: '1.4rem'}} />
										</Link>
									</div>
								);
							},
						},
					},
				];
		} else if (
			this.props.match.params.type === 'CarProtectionCategory' ){
				columns = [
					{
						name: 'category',
						label: 'Car Protection Category',
						options: {
							filter: false,
							sort: true,
						},
					},
					{
						name: 'priority',
						label: 'Priority ',
						options: {
							filter: false,
	
							customBodyRender: (priority, tableMeta) => {
	
								return <span>{priority}</span>;
							},
						},
					},
	
					{
						name: 'active',
						label: 'Status',
						options: {
							filter: true,
							sort: true,
							customBodyRender: (active, tableMeta) => {
								var Id = tableMeta.rowData[3];
								// console.log(tableMeta.rowData[3]);
								return (
									<Toggle
										id={'status_' + Id}
										checked={active}
										value={active}
										onChange={this.handleStatusChange.bind(Id, active)}
									/>
								);
							},
						},
					},
					{
						name: 'categoryId',
						label: 'Action',
						options: {
							filter: true,
							sort: true,
							customBodyRender: (categoryId) => {
								return (
									<div>
										<Link to={`/BusinessCategoryMaster/Update/CarProtectionCategory/${categoryId}`}>
											<FaEdit style={{fontSize: '1.4rem'}} />
										</Link>
									</div>
								);
							},
						},
					},
				];
		} else if (
			this.props.match.params.type === 'CarConditioningCategory' ){
				columns = [
					{
						name: 'category',
						label: 'Air Condition Category',
						options: {
							filter: false,
							sort: true,
						},
					},
					{
						name: 'priority',
						label: 'Priority ',
						options: {
							filter: false,
	
							customBodyRender: (priority, tableMeta) => {
	
								return <span>{priority}</span>;
							},
						},
					},
	
					{
						name: 'active',
						label: 'Status',
						options: {
							filter: true,
							sort: true,
							customBodyRender: (active, tableMeta) => {
								var Id = tableMeta.rowData[3];
								// console.log(tableMeta.rowData[3]);
								return (
									<Toggle
										id={'status_' + Id}
										checked={active}
										value={active}
										onChange={this.handleStatusChange.bind(Id, active)}
									/>
								);
							},
						},
					},
					{
						name: 'categoryId',
						label: 'Action',
						options: {
							filter: true,
							sort: true,
							customBodyRender: (categoryId) => {
								return (
									<div>
										<Link to={`/BusinessCategoryMaster/Update/CarConditioningCategory/${categoryId}`}>
											<FaEdit style={{fontSize: '1.4rem'}} />
										</Link>
									</div>
								);
							},
						},
					},
				];
			}

		const options = {
			filter: false,
			viewColumns: false,
			print: false,
			download: false,
			selectableRows: 'none',
			textLabels: {
				body: {
					noMatch: this.state.isSaving
						? 'Loading data..!'
						: 'Sorry, No Users Found',
					toolTip: 'Sort',
					columnHeaderTooltip: column => `Sort for ${column.label}`,
				},
			},
		};
		return (
			<div className='pcoded-inner-content'>
				<div className='main-body'>
					<div className='page-wrapper'>
						<div className='row'>
							<div className='col-sm-12'>
								<div className='card'>
									<div className='card-header'>
										{/* <h5>Product {this.props.match.params.type} List</h5> */}
										<Link
											to={`/BusinessCategoryMaster/Add/${this.props.match.params.type}`}
											className='btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger'
											data-modal='modal-13'>
											{' '}
											<i className='icofont icofont-plus m-r-5'></i>
											{` Add ${this.props.match.params.type} `}
										</Link>
									</div>

									<div className='card-block'>
										<div className='dt-responsive table-responsive'>
											{this.props.categorylist?.response !== undefined ? (
												<MUIDataTable
													title={`${this.props.match.params.type} List`}
													className='table-responsive'
													data={this.props.categorylist?.response}
													columns={columns}
													options={options}
												/>
											) : (
												<h4>Loading...</h4>
											)}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

BusinessCategoryMaster.propsTypes = {
	getGarageCategory: PropTypes.func.isRequired,
	getSparePartsCategory: PropTypes.func.isRequired,
	getCarDealerCategory: PropTypes.func.isRequired,
	getcarWashCategory: PropTypes.func.isRequired,
	getcarInsuranceCategory: PropTypes.func.isRequired,
	getdrivingSchoolCategory: PropTypes.func.isRequired,
	getcarProtectionCategory: PropTypes.func.isRequired,
	getairConditioningCategory: PropTypes.func.isRequired,
};

var mapStateToProps = state => ({
	categorylist: state?.home?.CategoryList,
});

export default connect(mapStateToProps, {
	getGarageCategory,
	getSparePartsCategory,
	getCarDealerCategory,
	getcarWashCategory,
	getcarInsuranceCategory,
	getdrivingSchoolCategory,
	getcarProtectionCategory,
	getairConditioningCategory,
})(BusinessCategoryMaster);
